import React from 'react'

export const EmailPart = () => {
  return (
    <div>EmailPart</div>
  )
}

export default EmailPart
